import React from 'react';
import {Document, Image, Page, Text, View} from '@react-pdf/renderer';
import {styles} from './PdfStyles.js'; // Assuming you have a PdfStyles.js
//import PdfSection from './PdfSection.js';
import PdfField from './PdfField.js';
import PdfCheckbox from './PdfCheckbox.js';
import finaLogo from "../../assets/images/FinaLogo.png";

const paddingRightSpacer = 20;

function convertDateFormat(dateString) {
    const parts = dateString.split('-'); // Split the string by the hyphen
    if (parts.length === 3) {
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
        return `${day}.${month}.${year}.`; // Reassemble in dd.mm.yyyy format
    } else {
        // Handle invalid input gracefully, e.g., throw an error or return null
        console.error("Invalid date string format. Expected yyyy-mm-dd.");
        return null;
    }
}

const FilledPristupnicaDocument = ({formData = {}}) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.logoContainer}>
                <Image style={styles.logo} src={finaLogo}/>
            </View>
            <Text style={styles.documentTitle}>PRISTUPNICA za ugovaranje paketa Fina e-Račun PLUS</Text>

            {/* Section 1: Podatci o poslovnom subjektu */}
            <Text style={styles.sectionTitle}>1. PODATCI O POSLOVNOM SUBJEKTU</Text>
            <Text style={styles.infoText}>
                U slučaju kada su dvije fizičke osobe (svaka sa svojim OIB-om) suvlasnici jedne registrirane djelatnosti
                (jedan MB), ovom Pristupnicom potrebno je odrediti čiji će OIB biti korišten za ugovaranje paketa. Ako
                jedna fizička osoba (jedan OIB) ima više registriranih djelatnosti (svaka s različitim MB-om), za svaku
                djelatnost popunjava se zasebna Pristupnica.
            </Text>

            <PdfField label="Naziv" value={formData.naziv}/>
            <View style={{flexDirection: 'row'}}>
                <View style={{flex: 1, paddingRight: paddingRightSpacer}}>
                    <PdfField label="Matični broj" value={formData.maticniBroj}/>
                </View>
                <View style={{flex: 1}}>
                    <PdfField label="OIB" value={formData.oib}/>
                </View>
            </View>
            <View style={{flexDirection: 'row'}}>
                <View style={{flex: 2, paddingRight: paddingRightSpacer}}>
                    <PdfField label="Adresa (mjesto, ulica i broj)" value={formData.adresa}/>
                </View>
                <View style={{flex: 0.8}}>
                    <PdfField label="Broj pošte" value={formData.brojPoste}/>
                </View>
            </View>
            <View style={{flexDirection: 'row'}}>
                <View style={{flex: 1, paddingRight: paddingRightSpacer}}>
                    <PdfField label="Država" value={formData.drzava}/>
                </View>
                <View style={{flex: 0.3}}>
                    <PdfField label="ISO kod države*" value={formData.isoKodDrzave}/>
                </View>
            </View>
            <View style={{flexDirection: 'row'}}>
                <Text style={styles.infoText}>
                    *ISO 3166, dvoslovni kod; međunarodna kratica za državu (npr. HR).
                </Text>
            </View>

            {/* Section 2: Poslovna jedinica */}
            <Text style={styles.sectionTitle}>2. POSLOVNA JEDINICA</Text>
            <Text style={styles.infoText}>
                Ako imate više poslovnih jedinica, prvo ih morate registrirati ispunjavanjem Pristupnice za registraciju
                poslovnog subjekta s poslovnim jedinicama na servise paketa Fina e-Račun PLUS.
                {'\n'}
                {'\n'}
                Na ovom mjestu možete dodijeliti prava korisniku za jednu ili više poslovnih jedinica. Ako korisniku
                želite dodijeliti različita prava (vidi dio „Prava korisnika“) za više poslovnih jedinica, za svaku je
                potrebno ispuniti ovu pristupnicu s pripadajućom šifrom. U slučaju da želite dodijeliti ista prava za
                sve poslovne jedinice, tada se šifra ne upisuje, a dovoljno je ispuniti samo ovu pristupnicu uz
                prethodnu registraciju poslovnih jedinica.
                {'\n'}
                {'\n'}
                Šifra poslovne jedinice mora odgovarati onoj navedenoj u pristupnici za registraciju poslovnih jedinica.
            </Text>
            <PdfField label="Šifra poslovne jedinice" value={formData.sifraPoslovneJedinice}/>

            {/* Section 3: PEPPOL */}
            <Text style={styles.sectionTitle}>
                3. PREKOGRANIČNA RAZMJENA RAČUNA
            </Text>

            <PdfCheckbox
                label="PEPPOL korisnik"
                checked={formData.peppolKorisnik}
            />

            <Text style={styles.infoText}>
                Označava funkcionalnost slanja i zaprimanja prekograničnih e-računa putem PEPPOL mreže.
                {'\n'}
                Ova funkcionalnost se dodatno naplaćuje prema redovnom Cjeniku Fine i Uvjetima korištenja usluge.
            </Text>


            {/* Section 4: Podatci o korisniku servisa */}
            <Text style={styles.sectionTitle}>4. PODATCI O KORISNIKU SERVISA</Text>
            <Text style={styles.infoText}>
                Osoba ovlaštena za zastupanje određuje korisnika servisa Fina e-Račun, Fina e-Arhiv i Fina Faktoring
                Platforma.
                {'\n'}
                Znakom X označite jedan od dva ponuđena načina pristupa navedenim servisima i ispunite pripadajuće
                podatke u nastavku.
                {'\n'}
                {'\n'}
                Odabir jedne opcije je obavezan!
            </Text>

            {formData.nacinPristupa === 'finaKripto' ?
                <>
                    <PdfCheckbox label="Pristup putem Fina kriptouređaja (USB stick/e-kartica)"
                                 checked={formData.nacinPristupa === 'finaKripto'}/>
                    <Text style={styles.smallText}>
                        Ovaj odabir vam omogućuje pristup servisima Fina e-Račun, Fina e-Arhiv i Fina Faktoring
                        platforma putem web aplikacije.
                        Molimo upišite podatke korisnika digitalnih certifikata na Fina kriptouređaju (USB
                        stick/e-kartica).
                    </Text>

                    <View style={{flexDirection: 'row'}}>
                        <View style={{flex: 1, paddingRight: paddingRightSpacer}}>
                            <PdfField
                                label="Ime i prezime"
                                value={formData.korisnikImePrezime}
                            />
                        </View>

                        <View style={{flex: 1}}>
                            <PdfField
                                label="OIB"
                                value={formData.korisnikOIB}
                            />
                        </View>
                    </View>

                    <View style={{flexDirection: 'row'}}>
                        <View style={{flex: 2, paddingRight: paddingRightSpacer}}>
                            <PdfField
                                label="Adresa – mjesto, ulica i broj"
                                value={formData.korisnikAdresa}
                            />
                        </View>

                        <View style={{flex: 0.8}}>
                            <PdfField
                                label="Broj pošte"
                                value={formData.korisnikBrojPoste}
                            />
                        </View>
                    </View>

                    <PdfField
                        label="Telefon"
                        value={formData.korisnikTelefon}
                    />

                    <PdfField
                        label="Adresa e-pošte"
                        value={formData.korisnikEmail}
                    />
                </>
                :
                <>
                    <PdfCheckbox label="Pristup aplikacijskim i/ili poslužiteljskim certifikatom"
                                 checked={formData.nacinPristupa === 'appCert'}/>
                    <Text style={styles.smallText}>
                        Ovaj odabir vam omogućava izravno povezivanje sa servisima Fina e-Račun i Fina e-Arhiv putem
                        računovodstvenog programa koji koristite. Svoj aplikacijski certifikat možete koristiti i za
                        pristup web aplikaciji Fina e-Arhiv i Fina Faktoring platforma
                    </Text>

                    <PdfField label="Naziv aplikacijskog certifikata" value={formData.nazivAplikacijskogCertifikata}/>
                    <PdfField label="Naziv poslužitelja (FQDN)*" value={formData.nazivPosluzitelja}/>
                    <PdfField label="Adresa e-pošte poslovnog subjekta**" value={formData.emailPoslovnogSubjekta}/>
                    <Text style={styles.infoText}>
                        *Poslužiteljski certifikat koristi se isključivo kod web servisa koji funkcioniraju putem
                        asinkrone razmjene poruka. U slučaju sinkrone razmjene, ovaj certifikat nije potreban.
                    </Text>
                    <Text style={styles.infoText}>
                        **Podatak je obavezan.
                    </Text>

                </>
            }


            <Text style={styles.pageNumbers} render={({pageNumber, totalPages}) => (
                `Stranica ${pageNumber} od ${totalPages}`
            )} fixed/>

        </Page>
        <Page size="A4" style={styles.page}>
            <View style={styles.logoContainer}>
                <Image style={styles.logo} src={finaLogo}/>
            </View>

            {/* Section 5: Cjenovni paket */}
            <Text style={styles.sectionTitle}>5. CJENOVNI PAKET</Text>
            <Text style={styles.infoText}>
                Paket e-Račun PLUS je skup usluga Fine koji se sastoji od servisa Fina e-Račun za poslovne subjekte,
                servisa Fina e-Arhiv i servisa Fina faktoring platforma i koji Fina Korisnicima Paketa e-Račun PLUS
                pruža niz pogodnosti prema Uvjetima korištenja.
            </Text>
            <View style={{flexDirection: 'row', flexWrap: 'wrap'}}>
                {['XS 15', 'S 30', 'S 55', 'S 80', 'S 120', 'M 200', 'M 300', 'M 400', 'L 500', 'L 650', 'XL (650+)'].map(paket => (
                    <View key={paket} style={{width: '33%', marginBottom: 3}}>
                        <PdfCheckbox label={paket} checked={formData.cjenovniPaket === paket}/>
                    </View>
                ))}
            </View>

            {/* Section 6: Prava korisnika */}
            <Text style={styles.sectionTitle}>6. PRAVA KORISNIKA</Text>
            <Text style={styles.infoText}>
                Korisniku se može dodijeliti jedno ili više prava za korištenje servisa.
                {'\n'}
                Za korištenje servisa Fina e-Arhiv obavezno je odabrati jedno od prava: „Administrator“ ili „Korisnik“.
                Pravo „Korisnik“ moguće je dodijeliti samo ako je prethodno barem jednom korisniku već dodijeljeno pravo
                „Administrator“.
            </Text>
            <View style={{flexDirection: 'row'}}>
                <View style={{flex: 0.8, paddingRight: paddingRightSpacer}}>
                    <Text style={styles.subSectionTitle}>Fina e-Račun</Text>
                    <PdfCheckbox label="Unos" checked={formData.eRacunUnos}/>
                    <PdfCheckbox label="Potpis i slanje" checked={formData.eRacunPotpisSlanje}/>
                    <PdfCheckbox label="Pregled i dohvat" checked={formData.eRacunPregledDohvat}/>
                    <PdfCheckbox label="Slanje obavijesti o plaćanju"
                                 checked={formData.eRacunSlanjeObavijestiPlacanje}/>
                    <PdfCheckbox label="Pristup svim poslovnim jedinicama[1]" checked={formData.eRacunPristupSvimPJ}/>
                    <PdfCheckbox label="Prava u ime drugog poslovnog subjekta[2]"
                                 checked={formData.eRacunPravaDrugoIme}/>
                </View>
                <View style={{flex: 0.8, paddingRight: paddingRightSpacer}}>
                    <Text style={styles.subSectionTitle}>Fina e-Arhiv</Text>
                    <PdfCheckbox label="Administrator[3]" checked={formData.eArhivAdministrator}/>
                    <PdfCheckbox label="Korisnik[4]" checked={formData.eArhivKorisnik}/>
                    <PdfCheckbox label="Pristup svim poslovnim jedinicama[1]" checked={formData.eArhivPristupSvimPJ}/>
                    <PdfCheckbox label="Prava u ime drugog poslovnog subjekta[2]"
                                 checked={formData.eArhivPravaDrugoIme}/>
                </View>
                <View style={{flex: 0.8}}>
                    <Text style={styles.subSectionTitle}>Fina Faktoring Platforma</Text>
                    <PdfCheckbox label="Prodavatelj pregled[5]" checked={formData.faktoringProdavateljPregled}/>
                    <PdfCheckbox label="Prodavatelj potpis[6]" checked={formData.faktoringProdavateljPotpis}/>
                    <PdfCheckbox label="Dužnik[7]" checked={formData.faktoringDuznik}/>
                    <PdfCheckbox label="Prava u ime drugog poslovnog subjekta[2]"
                                 checked={formData.faktoringPravaDrugoIme}/>
                </View>
            </View>
            <Text style={styles.infoText}>
                Napomena: Ako Fina e-Računu pristupate aplikacijskim certifikatom, obavezno je odabrati pravo „Pregled i
                dohvat “ i/ili „Potpis i slanje“, ovisno o tome trebate li primati, slati ili obavljati obje funkcije u
                vezi s e-računima. Ako Fina Faktoring platformi pristupate aplikacijskim certifikatom, ne možete
                odabrati prava „Prodavatelj potpis“ i „Dužnik“, jer je za potpisivanje dokumenata potreban certifikat na
                Fina kriptouređaju (USB stick/e-kartica).
                {'\n'}
                {'\n'}
                [1]Pristup svim poslovnim jedinicama - ako korisniku želite dodijeliti ista prava za sve poslovne
                jedinice, ovdje označite pravo Pristup svim poslovnim jedinicama.
                {'\n'}
                [2]Prava u ime drugog poslovnog subjekta - ako servis koristite u ime drugog subjekta, na pristupnici
                označite opciju „Prava u ime drugog poslovnog subjekta“. Uz ovu Pristupnicu priložite Punomoć u kojoj
                vaš opunomoćitelj treba označiti prava koja vam dodjeljuje. Obrazac punomoći dostupan je na web stranici
                www.fina.hr.
                {'\n'}
                [3]Administrator - ovlaštena osoba s pravom pristupa svim funkcionalnostima servisa Fina e-Arhiv. Može
                upravljati elektroničkim dokumentima i sadržajem, te dodjeljivati prava drugim korisnicima za određene
                spremnike.
                {'\n'}
                [4]Korisnik - osoba kojoj je Administrator dodijelio prava za pristup i korištenje određenog spremnika u
                servisu Fina e-Arhiv.
                {'\n'}
                [5]Prodavatelj pregled - omogućuje prodavatelju tražbina uvid u dokumentaciju koja je predmet faktoringa
                te pristup svim pripadajućim opcijama i informacijama.
                {'\n'}
                [6]Prodavatelj potpis - uključuje sva prava iz stavke "Prodavatelj pregled", uz dodatnu mogućnost
                potpisivanja dokumentacije.
                {'\n'}
                [7]Dužnik - omogućuje korisniku uvid u dokumentaciju vezanu uz faktoring i pravo na njeno potpisivanje.
            </Text>
            <Text style={styles.pageNumbers} render={({pageNumber, totalPages}) => (
                `Stranica ${pageNumber} od ${totalPages}`
            )} fixed/>
        </Page>
        <Page size="A4" style={styles.page}>
            <View style={styles.logoContainer}>
                <Image style={styles.logo} src={finaLogo}/>
            </View>
            <Text style={styles.infoText}>
                Sukladno čl. 80. Zakona o porezu na dodanu vrijednost i čl. 161. Pravilnika o porezu na dodanu
                vrijednost, izjavljujem da sam odabirom prava Pregled i prihvat i/ili Slanje obavijesti o plaćanju te
                potpisom ove Pristupnice, suglasan/a zaprimati račune svih svojih dobavljača dostavljenih putem servisa
                Fina e-Račun.
            </Text>
            {/* Signature Block */}
            <View style={styles.signatureBlock}>
                <View style={styles.signatureLineContainerFinaEmployee}>
                    <Text style={styles.signatureText}>{formData.mjesto}</Text>
                    <Text style={styles.signatureLabel}>Mjesto</Text>
                </View>
                <View style={styles.signatureLineContainerFinaEmployee}>
                    <Text style={styles.signatureText}>{convertDateFormat(formData.datum)}</Text>
                    <Text style={styles.signatureLabel}>Datum</Text>
                </View>
                <View style={styles.signatureLineContainerFinaEmployee}>
                    <Text style={styles.signatureText}>{formData.ovlastenikImePrezime + ' '}</Text>
                    <Text style={styles.signatureLabel}>Ime i prezime osobe ovlaštene za zastupanje</Text>
                </View>
            </View>

            <View style={styles.signatureBlock}>
                <View style={styles.signatureLineContainer}>
                    <Text style={styles.signatureText}> </Text>
                    <Text style={styles.signatureLabel}>Potpis korisnika servisa</Text>
                </View>
                <View style={styles.signatureLineContainer}>
                    <Text style={styles.signatureText}> </Text>
                    <Text style={styles.signatureLabel}>Potpis osobe ovlaštene za zastupanje</Text>
                </View>
            </View>
            <Text style={styles.infoText}>
                Popunjava djelatnik Fine
            </Text>
            <View style={styles.signatureBlock}>
                <View style={styles.signatureLineContainerFinaEmployee}>
                    <Text style={styles.signatureText}> </Text>
                    <Text style={styles.signatureLabel}>Datum</Text>
                </View>
                <View style={styles.signatureLineContainerFinaEmployee}>
                    <Text style={styles.signatureText}> </Text>
                    <Text style={styles.signatureLabel}>Potpis</Text>
                </View>
                <View style={styles.signatureLineContainerFinaEmployee}>
                    <Text style={styles.signatureTextStamp}> </Text>
                    <Text style={styles.signatureLabel}>Štambilj</Text>
                </View>
            </View>

            {/* Privacy Notice */}
            <View style={styles.privacySection}>
                <Text style={styles.privacySectionTitle}>Informacije ispitaniku* o obradi osobnih podataka prikupljenih
                    ovom Pristupnicom za ugovaranje paketa Fina e-Račun PLUS</Text>
                <Text style={styles.privacyText}>
                    Voditelj obrade osobnih podataka: Financijska agencija, Ulica grada Vukovara 70, 10 000 Zagreb, OIB:
                    85821130368, info@fina.hr / info telefon 0800 0080
                    {'\n'}
                    {'\n'}
                    Kontaktni podaci Službenika za zaštitu podataka: dpo@fina.hr
                    {'\n'}
                    {'\n'}
                    Pravna osnova i svrha obrade osobnih podataka: Osobni podatci prikupljeni ovom Pristupnicom za
                    ugovaranje paketa Fina e-Račun PLUS obrađuju se u svrhu pristupa servisima Fina e-Račun, Fina
                    e-Arhiv i Fina Faktoring platforma i nužni su za izvršenje ugovora u kojem je ispitanik stranka
                    (čl.6.1.b Opće uredbe o zaštiti podataka).
                    {'\n'}
                    {'\n'}
                    Primatelji osobnih podataka: Osobni podatci koji se prikupljaju ovom Pristupnicom ne predaju se
                    drugim primateljima. Pohrana osobnih podataka: Osobni podatci čuvat će se na način određen propisima
                    o arhiviranju, na rok od 10 godina od otkaza usluge ili od isteka certifikata na kojeg se prava
                    korištenja servisa odnose.
                    {'\n'}
                    {'\n'}
                    Prava ispitanika: Ispitanik ima pravo od Fine zatražiti pristup, ispravak, brisanje, prijenos
                    podataka i ograničavanje obrade te ima pravo podnijeti prigovor na obradu osobnih podataka koji se
                    na njega odnose, ako su za to ispunjene propisane pretpostavke. Zahtjev u vezi s prethodnim pravima
                    može se podnijeti u bilo kojoj poslovnoj jedinici Fine, pisanim putem na adresu voditelja obrade ili
                    na adresu elektroničke pošte Službenika za zaštitu podataka.
                    {'\n'}
                    {'\n'}
                    Pritužba na obradu osobnih podataka: Ispitanik ima pravo podnijeti pritužbu na obradu osobnih
                    podataka na adresu nadzornog tijela - Agencije za zaštitu osobnih podataka, na adresu elektroničke
                    pošte azop@azop.hr ili putem online obrasca na stranici www.azop.hr.
                    {'\n'}
                    {'\n'}
                    Prigovor na obradu osobnih podataka možete podnijeti nadzornom tijelu - Agenciji za zaštitu osobnih
                    podataka, Selska cesta 136, Zagreb, azop@azop.hr, www.azop.hr
                    {'\n'}
                    {'\n'}
                    {'\n'}
                    *Ispitanik u smislu ove Pristupnice je ovlaštena osoba i korisnik servisa Fina e-Račun, Fina e-Arhiv
                    i Fina Faktoring platofrma, čiji se podatci prikupljaju ovom Pristupnicom.
                </Text>
            </View>
            <Text style={styles.pageNumbers} render={({pageNumber, totalPages}) => (
                `Stranica ${pageNumber} od ${totalPages}`
            )} fixed/>
        </Page>
    </Document>
);

export default FilledPristupnicaDocument;